import { AxiosClient } from "./AxiosClient";

export const searchMessages = (q, limit = 10) => {
  try {
    return AxiosClient.get(
      "search/messages?q=" + encodeURIComponent(q) + "&limit=" + limit,
    );
  } catch (e) {
    console.log(e);
  }
};
